//get FAQ
export const GET_FAQ = "GET_FAQ";

//Insert FAQ
export const INSERT_FAQ = "INSERT_FAQ";

//Update FAQ
export const UPDATE_FAQ = "UPDATE_FAQ";

//Delete FAQ
export const DELETE_FAQ = "DELETE_FAQ";

//Open and Close Dialog
export const OPEN_FAQ_DIALOG = "OPEN_FAQ_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";

//toast
export const OPEN_FAQ_TOAST = "OPEN_FAQ_TOAST";
export const CLOSE_FAQ_TOAST = "CLOSE_FAQ_TOAST";
